import React from 'react';
import './BoutonRetour.scss';

function BoutonRecharge() {
    
    return (
    <div className="wrapper-button">
            <p className="btn-homepage" data-text="Next item">Next item</p>
    </div>
    )
}

export default BoutonRecharge;